module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIyOSIgaGVpZ2h0PSIxNiIgdmlld0JveD0iMCAwIDI5IDE2Ij4NCiAgPGcgaWQ9Ik9GRi1zbWFsbCIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoMzQ2IDIwNDUpIHJvdGF0ZSgxODApIj4NCiAgICA8cmVjdCBpZD0iUmVjdGFuZ2xlXzEwMyIgZGF0YS1uYW1lPSJSZWN0YW5nbGUgMTAzIiB3aWR0aD0iMjkiIGhlaWdodD0iMTYiIHJ4PSI4IiB0cmFuc2Zvcm09InRyYW5zbGF0ZSgzMTcgMjAyOSkiIGZpbGw9IiNiZmI5YWUiLz4NCiAgICA8Y2lyY2xlIGlkPSJFbGxpcHNlXzE3IiBkYXRhLW5hbWU9IkVsbGlwc2UgMTciIGN4PSI2IiBjeT0iNiIgcj0iNiIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoMzMyIDIwMzEpIiBmaWxsPSIjZmZmIi8+DQogIDwvZz4NCjwvc3ZnPg0K"


//////////////////
// WEBPACK FOOTER
// ./src/assets/OFF-small.svg
// module id = +cpU
// module chunks = 18